export const userSubscriptionState = {
  active: "active",
  pastDue: "past_due",
  canceled: "canceled",
  trialing: "trialing",
};

export const userState = {
  lead: "lead",
  subscriber: "subscriber",
  suspended: "suspended",
};
